import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

// Thin wrapper so callers don't need to remember the resolver wiring.
// Use this when you want the methods bag without rendering a <Form> root —
// e.g. when building a multi-step flow or a custom layout.
//
// An explicit `resolver` (e.g. one wrapped by useCrossEdgeResolver to bake
// cross-field validation into the resolver's output) takes precedence over
// the schema-based default. Pass schema in either case so the call site
// still reads like "this is the form's schema."
export function useCgForm({ schema, defaultValues, mode = 'onTouched', resolver, ...rest }) {
  const effectiveResolver = resolver ?? (schema ? zodResolver(schema) : undefined);
  return useForm({
    resolver: effectiveResolver,
    defaultValues,
    mode,
    ...rest,
  });
}

export default useCgForm;
